/**
 * @copyright 2025 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { HiOutlineBookOpen, HiOutlineVideoCamera, HiOutlineChatBubbleBottomCenter } from 'react-icons/hi2'

const AdditionalResources: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div className="card card-border bg-base-100 hover:shadow-md transition-shadow">
        <div className="card-body text-center">
          <div className="avatar placeholder mx-auto mb-4">
            <div className="bg-accent text-accent-content rounded-full w-16 h-16 flex items-center justify-center relative">
              <HiOutlineBookOpen className="w-6 h-6 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
            </div>
          </div>
          <h3 className="card-title text-base justify-center mb-2">Documentation</h3>
          <p className="text-sm text-base-content/70 mb-4">Browse our comprehensive guides and tutorials</p>
          <div className="card-actions justify-center">
            <button className="btn btn-accent btn-sm btn-outline">Browse Docs</button>
          </div>
        </div>
      </div>

      <div className="card card-border bg-base-100 hover:shadow-md transition-shadow">
        <div className="card-body text-center">
          <div className="avatar placeholder mx-auto mb-4">
            <div className="bg-info text-info-content rounded-full w-16 h-16 flex items-center justify-center relative">
              <HiOutlineVideoCamera className="w-6 h-6 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
            </div>
          </div>
          <h3 className="card-title text-base justify-center mb-2">Video Tutorials</h3>
          <p className="text-sm text-base-content/70 mb-4">Watch step-by-step video guides</p>
          <div className="card-actions justify-center">
            <button className="btn btn-info btn-sm btn-outline">Watch Videos</button>
          </div>
        </div>
      </div>

      <div className="card card-border bg-base-100 hover:shadow-md transition-shadow">
        <div className="card-body text-center">
          <div className="avatar placeholder mx-auto mb-4">
            <div className="bg-success text-success-content rounded-full w-16 h-16 flex items-center justify-center relative">
              <HiOutlineChatBubbleBottomCenter className="w-6 h-6 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
            </div>
          </div>
          <h3 className="card-title text-base justify-center mb-2">Community Forum</h3>
          <p className="text-sm text-base-content/70 mb-4">Connect with other users and experts</p>
          <div className="card-actions justify-center">
            <button className="btn btn-success btn-sm btn-outline">Join Forum</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdditionalResources
